<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<p class="ded">For Debbie, the sailor of the family.</p>
<a id="page_vi"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?92fb578e